import { cva } from 'class-variance-authority';

export const progressBarFillVariants = cva([], {
  variants: {
    status: {
      default: ['bg-color-comp-progress-bar-neutral-on-container'],
      primary: ['bg-color-comp-progress-bar-info-on-container'],
      primaryMuted: ['bg-color-ref-primary-primary-40'],
      primarySubtle: ['bg-color-ref-primary-primary-20'],
      success: ['bg-color-comp-progress-bar-success-on-container'],
      warning: ['bg-color-comp-progress-bar-warning-on-container'],
      alert: ['bg-color-sys-starfish-orange-40'],
      danger: ['bg-color-comp-progress-bar-danger-on-container'],
    },
  },
  defaultVariants: {
    status: 'default',
  },
});
